import { render, staticRenderFns } from "./KpTooltip.vue?vue&type=template&id=16ebb607&scoped=true"
import script from "./KpTooltip.vue?vue&type=script&lang=js"
export * from "./KpTooltip.vue?vue&type=script&lang=js"
import style0 from "./KpTooltip.vue?vue&type=style&index=0&id=16ebb607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebb607",
  null
  
)

export default component.exports